import type { SpaceWire } from 'types/space';
import type { SpaceAction } from '../types';
import { isLegacyBridgeEventType, type LegacyBridgeEventType } from './legacyEventTypes';

export interface WireDelivery {
  wireId: string;
  to: string;
  legacyEventType?: LegacyBridgeEventType;
}

/**
 * Matches an emitted `SpaceAction` against a document's declared `wires[]`, returning every
 * routed delivery. `legacyEventType` is included only when it falls in the closed legacy set —
 * an undeclared name is a validation-time error (`SpaceWire.legacyEventType`), never bridged at
 * runtime even if a stale/unvalidated document somehow carries one (SC6, SC11).
 */
export function resolveWireTargets(wires: SpaceWire[] | undefined, action: SpaceAction): WireDelivery[] {
  if (!wires?.length) return [];
  return wires
    .filter((wire) => wire.from === action.componentId && wire.action === action.name)
    .map((wire) => ({
      wireId: wire.id,
      to: wire.to,
      legacyEventType: isLegacyBridgeEventType(wire.legacyEventType) ? wire.legacyEventType : undefined,
    }));
}
